(function($) {
  'use strict';

  var $overlay = $('#VariantPickerModal');
  var $modal = $overlay.find('.vpm-modal');
  var $title = $('#vpmProductTitle');
  var $image = $('#vpmProductImage');
  var $price = $('#vpmProductPrice');
  var $variants = $('#vpmVariants');
  var $description = $('#vpmDescription');
  var $addBtn = $('#vpmAddToCart');
  var $cancelBtn = $('#vpmCancel');
  var $closeBtn = $overlay.find('.vpm-close');

  var selectedVariantId = null;
  var currentProductData = null;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function openModal(productData) {
    currentProductData = productData;
    selectedVariantId = null;

    // Set product info
    $title.text(productData.title);
    $image.attr('src', productData.image).attr('alt', productData.title);
    $price.html(productData.price_formatted);

    // Build variant cards
    var html = '';
    productData.variants.forEach(function(variant) {
      var unavailableClass = !variant.available ? ' is-unavailable' : '';
      var disabledAttr = !variant.available ? ' disabled' : '';

      var pricingHtml = '<span>' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && parseInt(variant.compare_at_price) > variant.price) {
        var savings = parseInt(variant.compare_at_price) - variant.price;
        pricingHtml += '<span class="vpm-variant-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        pricingHtml += '<span class="vpm-variant-savings">Save ' + formatMoney(savings) + '</span>';
      }

      var imgHtml = '';
      var variantImgSrc = variant.image_src || productData.image;
      if (variantImgSrc) {
        imgHtml = '<div class="vpm-variant-img"><img src="' + variantImgSrc + '" alt="' + (variant.title || '').replace(/"/g, '&quot;') + '"></div>';
      }

      html += '<label class="vpm-variant-card' + unavailableClass + '" data-variant-id="' + variant.id + '">' +
        '<input type="radio" name="vpm-variant" value="' + variant.id + '"' + disabledAttr + '>' +
        imgHtml +
        '<div class="vpm-variant-details">' +
          '<p class="vpm-variant-name">' + variant.title + '</p>' +
          '<p class="vpm-variant-pricing">' + pricingHtml + '</p>' +
        '</div>' +
        '<div class="vpm-variant-check">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</div>' +
      '</label>';
    });

    $variants.html(html);
    $description.hide().empty();
    $addBtn.prop('disabled', true).removeClass('is-loading');

    // Show modal
    $overlay.addClass('is-active').attr('aria-hidden', 'false');
    $('body').addClass('vpm-open');
  }

  function closeModal() {
    $overlay.removeClass('is-active').attr('aria-hidden', 'true');
    $('body').removeClass('vpm-open');
    selectedVariantId = null;
    currentProductData = null;
  }

  function selectVariant(variantId) {
    selectedVariantId = variantId;

    // Update visual selection
    $variants.find('.vpm-variant-card').removeClass('is-selected');
    $variants.find('.vpm-variant-card[data-variant-id="' + variantId + '"]').addClass('is-selected');

    // Update main product image to show selected variant image
    var variant = null;
    if (currentProductData) {
      for (var i = 0; i < currentProductData.variants.length; i++) {
        if (currentProductData.variants[i].id == variantId) {
          variant = currentProductData.variants[i];
          break;
        }
      }
    }

    // Enable add to cart button immediately
    $addBtn.prop('disabled', false);

    if (variant) {
      var imgSrc = variant.image_src || (currentProductData && currentProductData.image);
      if (imgSrc) {
        $image.attr('src', imgSrc);
      }

      // Show description if available (ignore empty/whitespace-only values)
      $description.html(variant.description || '');
      if ($description.text().trim()) {
        $description.show();
      } else {
        $description.hide().empty();
      }

      // Update price display
      var priceHtml = formatMoney(variant.price);
      if (variant.compare_at_price && parseInt(variant.compare_at_price) > variant.price) {
        priceHtml += ' <span style="text-decoration:line-through;opacity:0.5;margin-left:6px;">' + formatMoney(variant.compare_at_price) + '</span>';
      }
      $price.html(priceHtml);
    }
  }

  function addToCart() {
    if (!selectedVariantId) return;

    $addBtn.addClass('is-loading').prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: selectedVariantId
      },
      dataType: 'json',
      success: function() {
        closeModal();
        // Open Rebuy Smart Cart
        if (window.Rebuy && window.Rebuy.SmartCart) {
          window.Rebuy.SmartCart.show();
        }
      },
      error: function(xhr) {
        $addBtn.removeClass('is-loading').prop('disabled', false);
        var msg = 'Could not add to cart. Please try again.';
        if (xhr.responseJSON && xhr.responseJSON.description) {
          msg = xhr.responseJSON.description;
        }
        alert(msg);
      }
    });
  }

  // --- Event Listeners ---

  // Variant card selection
  $variants.on('click', '.vpm-variant-card:not(.is-unavailable)', function() {
    var variantId = $(this).data('variant-id');
    $(this).find('input[type="radio"]').prop('checked', true);
    selectVariant(variantId);
  });

  // Add to cart confirm
  $addBtn.on('click', addToCart);

  // Close handlers
  $cancelBtn.on('click', closeModal);
  $closeBtn.on('click', closeModal);
  $overlay.on('click', function(e) {
    if (e.target === this) closeModal();
  });

  // Escape key
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $overlay.hasClass('is-active')) {
      closeModal();
    }
  });

  // --- Intercept Add to Cart on product cards ---

  $(document).on('submit', '.grid-product__atc-form', function(e) {
    var $form = $(this);
    var $btn = $form.find('.add-to-cart[data-has-variants="true"]');

    if ($btn.length === 0) return; // Single variant - let normal flow handle it

    e.preventDefault();
    e.stopImmediatePropagation();

    // Get variant data from the product card
    var $card = $form.closest('.grid-product__content');
    var $dataScript = $card.find('.variant-picker-data');

    if ($dataScript.length === 0) return;

    try {
      var productData = JSON.parse($dataScript.text());
      openModal(productData);
    } catch (err) {
      // Fallback: let the form submit normally
      $form.off('submit').submit();
    }
  });

  // Also intercept direct button clicks (in case submit isn't triggered)
  $(document).on('click', '.add-to-cart[data-has-variants="true"]', function(e) {
    var $btn = $(this);
    var $form = $btn.closest('.grid-product__atc-form');
    var $card = $form.closest('.grid-product__content');
    var $dataScript = $card.find('.variant-picker-data');

    if ($dataScript.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      var productData = JSON.parse($dataScript.text());
      openModal(productData);
    } catch (err) {
      // Fallback: do nothing, let normal behavior proceed
    }
  });

})(jQuery);
